/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'export': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M17.86 18l1.04 1c-1.4 1.2-3.96 2-6.9 2-4.41 0-8-1.79-8-4V7c0-2.21 3.58-4 8-4 2.95 0 5.5.8 6.9 2l-1.04 1-.36.4C16.65 5.77 14.78 5 12 5 8.13 5 6 6.5 6 7s2.13 2 6 2c1.37 0 2.5-.19 3.42-.46l.96.96H13.5v1.42c-.5.05-1 .08-1.5.08-2.39 0-4.53-.53-6-1.36v2.81C7.3 13.4 9.58 14 12 14c.5 0 1-.03 1.5-.08v.58h2.88l-1 1 .12.11c-1.09.25-2.26.39-3.5.39-2.28 0-4.39-.45-6-1.23V17c0 .5 2.13 2 6 2 2.78 0 4.65-.77 5.5-1.39l.36.39m1.06-10.92L17.5 8.5 20 11h-5v2h5l-2.5 2.5 1.42 1.42L23.84 12l-4.92-4.92z"/>'
  }
})
